import React from 'react';
import { IconProps } from './type';

export function ChevronUp({ color = 'currentColor', ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55806 15.4419C6.80214 15.686 7.19786 15.686 7.44194 15.4419L12 10.8839L16.5581 15.4419C16.8021 15.686 17.1979 15.686 17.4419 15.4419C17.686 15.1979 17.686 14.8021 17.4419 14.5581L12.4419 9.55806C12.1979 9.31398 11.8021 9.31398 11.5581 9.55806L6.55806 14.5581C6.31398 14.8021 6.31398 15.1979 6.55806 15.4419Z"
        fill={color}
      />
    </svg>
  );
}
